import * as React from 'react'
import { Container, Typography } from '@mui/material'

/**
 * NotFound error component
 */
const NotFound = () => {
  return (
    <Container maxWidth="sm" sx={{ minHeight: '50vh', my: 6, textAlign: 'center' }}>
      <Typography variant="h1" sx={{ fontSize: '12rem', fontWeight: 'fontWeightMedium', color: 'brand.main' }}>404</Typography>
      <Typography variant="h4" sx={{ fontWeight: 'fontWeightMedium' }}>Oops! That page can't be found.</Typography>
    </Container>
  )
}

export default NotFound
